import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline, Container } from '@mui/material';
import theme from './theme';
import site from './content';
import FileUpload from './components/FileUpload';
import LandingPage from './components/LandingPage';
import FormatPage from './components/FormatPage';
import { ContentPage, NotFoundPage } from './components/ContentPage';
import Layout from './components/Layout';
import { STEPS, trackStep } from './utils/tracking';

function App() {
  useEffect(() => {
    trackStep(STEPS.LANDED);
  }, []);

  // Set the correct basename based on environment and host
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const basename = isLocalhost ? '/' : '';  // Use root path in production, / in localhost

  // Pages and paths come from content/site.json, which the server also uses
  // (logo_saas/seo.py), so both sides always agree on which pages exist.
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router basename={basename}>
        <Layout>
          <Routes>
            <Route path={site.home.path} element={<LandingPage />} />
            <Route path={site.upload.path} element={
              <Container maxWidth="md" sx={{ py: { xs: 4, md: 7 } }}>
                <FileUpload />
              </Container>
            } />
            {site.formats.map((format) => (
              <Route key={format.path} path={format.path} element={<FormatPage format={format} />} />
            ))}
            <Route path={site.about.path} element={<ContentPage page={site.about} />} />
            <Route path={site.privacy.path} element={<ContentPage page={site.privacy} />} />
            <Route path={site.terms.path} element={<ContentPage page={site.terms} />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;
